module.exports = __webpack_public_path__ + "img/ico-blue-error.9325f223.svg";